import './TableHeaderColumn.scss';

function TableHeaderColumn({ item }) {
  return <div className={`table-header-column ${item.key}`}>{item.name}</div>;
}

export default TableHeaderColumn;
